import { useEffect, useSyncExternalStore } from 'react'
import { useUiStore } from '@/stores/ui'

const query = '(prefers-color-scheme: dark)'

function subscribe(callback: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {}
  const mql = window.matchMedia(query)
  mql.addEventListener('change', callback)
  return () => mql.removeEventListener('change', callback)
}

function systemPrefersDark() {
  return typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(query).matches
}

export function useResolvedTheme(): 'light' | 'dark' {
  const theme = useUiStore((s) => s.theme)
  const systemDark = useSyncExternalStore(subscribe, systemPrefersDark, () => false)
  if (theme === 'system') return systemDark ? 'dark' : 'light'
  return theme
}

/** Applies the resolved theme to <html>. Mount once at the root. */
export function useApplyTheme() {
  const resolved = useResolvedTheme()
  useEffect(() => {
    const root = document.documentElement
    root.classList.toggle('dark', resolved === 'dark')
    root.style.colorScheme = resolved
  }, [resolved])
}
